




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackToTop extends Vue {
  @Prop() private msg!: string;
}
